function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
import { motion, AnimatePresence } from '../../_snowpack/pkg/framer-motion.js';
import OutsideClickListener from '../modules/outside-click-listener.js';
import { Button } from './index.js';
const Outer = styled.span.withConfig({
  displayName: "fab__Outer",
  componentId: "q4hymc-0"
})(["display:inline-block;position:relative;z-index:99;"]);
const ButtonWrap = styled.span.withConfig({
  displayName: "fab__ButtonWrap",
  componentId: "q4hymc-1"
})(["position:relative;z-index:1;"]);
const Children = styled.span.withConfig({
  displayName: "fab__Children",
  componentId: "q4hymc-2"
})(["position:absolute;z-index:0;left:0;bottom:0;width:100%;display:flex;flex-direction:column;align-items:flex-start;margin-bottom:", ";"], p => p.paddToButton);

function getItemAnimation({
  index,
  itemCount
}) {
  const initial = {
    opacity: 0,
    scale: 0.25,
    y: 50
  };
  const animate = {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      delay: (itemCount - index) * 0.05,
      type: 'spring',
      mass: 0.4
    }
  };
  return {
    initial,
    animate,
    exit: { ...initial,
      transition: {
        delay: index * 0.05,
        duration: 0.1
      }
    }
  };
}

export class Fab extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      show: false
    });

    _defineProperty(this, "onKeypress", evt => {
      if (evt.key === 'Escape') {
        this.close();
      }
    });

    _defineProperty(this, "updateListener", () => {
      const {
        show
      } = this.state;

      if (show) {
        this.outsideClickHandler.start();
      } else {
        this.outsideClickHandler.stop();
      }
    });

    _defineProperty(this, "close", () => this.setState({
      show: false
    }, this.updateListener));

    _defineProperty(this, "open", () => this.setState({
      show: true
    }, this.updateListener));

    _defineProperty(this, "toggle", () => this.setState(s => ({
      show: !s.show
    }), this.updateListener));

    _defineProperty(this, "getRef", el => this.ref = el);

    _defineProperty(this, "actionOnClick", fn => {
      this.close();

      if (fn) {
        fn();
      }
    });
  }

  componentDidMount() {
    this.outsideClickHandler = new OutsideClickListener({
      getElement: () => this.ref,
      onClickOutside: this.close
    });
  }

  render() {
    const {
      show
    } = this.state;
    const {
      children,
      text = '?',
      clean = false,
      paddToButton = '40%'
    } = this.props;
    const childrenToDisplay = !show ? [] : React.Children.map(children, child => child);
    return /*#__PURE__*/React.createElement(Outer, {
      ref: this.getRef,
      onKeyDown: this.onKeypress
    }, /*#__PURE__*/React.createElement(ButtonWrap, null, /*#__PURE__*/React.createElement(Button, {
      small: true,
      clean: clean,
      type: "button",
      onClick: this.toggle
    }, text)), /*#__PURE__*/React.createElement(Children, {
      paddToButton: paddToButton
    }, /*#__PURE__*/React.createElement(AnimatePresence, null, childrenToDisplay.map((child, index) => /*#__PURE__*/React.createElement(motion.div, _extends({
      key: index
    }, getItemAnimation({
      index,
      itemCount: childrenToDisplay.length
    }), {
      style: {
        marginBottom: '15px'
      }
    }), /*#__PURE__*/React.cloneElement(child, {
      'aria-hidden': !show,
      ...child.props,
      onClick: () => this.actionOnClick(child.props.onClick)
    }))))));
  }

}